/**
 * Date <-> form-state helpers shared by the policy, reimbursement and claim-item
 * inputs. Kept in their own module so TerminationDateInput and PolicyCreateInputs
 * no longer import each other (!4843 review).
 */
export type DateInputValue = string | Date | null | undefined;

// Parse: input → form state (keep as YYYY-MM-DD string)
export const parseDateInput = (v: DateInputValue): string | null => {
  if (!v) return null;
  if (v instanceof Date) {
    return v.toISOString().split("T")[0];
  }
  return v.includes("T") ? v.split("T")[0] : v;
};

// Format: form state → display (YYYY-MM-DD string stays as is)
export const formatDateDisplay = (v: DateInputValue): string => {
  if (!v) return "";
  if (v instanceof Date) {
    return v.toISOString().split("T")[0];
  }
  return v.split("T")[0];
};
